import type { Moment } from 'moment'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import CalendarDateRangePicker from 'components/Common/Calendar/DateRangePicker'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'

interface Props {
  date?: Moment
  minDate?: Moment
  maxDate?: Moment
  onDateChange: (date?: Moment) => void
}

// Force the DatePicker to have a min-height so it doesn't jump up and down
// Pending fixing this in the design library
const DatePickerMinHeightWrapper = styled.div`
  min-height: ${rem(271)};

  ${mediaQueryUp.tablet} {
    min-height: ${rem(340)};
  }
`

function DatePicker({ date, onDateChange, minDate, maxDate }: Props) {
  const intl = useIntl()

  return (
    <DatePickerMinHeightWrapper>
      <CalendarDateRangePicker
        onDatesChange={(dates) => {
          onDateChange(dates.startDate)
        }}
        startLabel={intl.formatMessage({
          id: 'RvUhu6Yvr3c4vnUI076T',
          defaultMessage: 'Start date',
          description: 'Form field label for the start date in the trip date picker',
        })}
        startDate={date}
        endDate={date}
        minDate={minDate?.toDate()}
        maxDate={maxDate?.toDate()}
      />
    </DatePickerMinHeightWrapper>
  )
}

export default DatePicker
